// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b2cf4cb3","453":"13b89fa0"}[chunkId] + ".chunk.js";
};